document.querySelectorAll(".itemColorsSlider").forEach((sliderElement) => {
  const colorsSlider = new Swiper(sliderElement, {
    loop: true,
    effect: "fade",
    slidesPerView: 1,
    speed: 1000,
    autoplay: {
      delay: 1500, // 自動再生の遅延時間（ms）
      disableOnInteraction: false, // ユーザーが操作してもautoplayを無効にしない
    },
  });

  colorsSlider.autoplay.stop();

  // hoverしたときにautoplayを開始
  sliderElement.parentElement.addEventListener("mouseover", function () {
    colorsSlider.autoplay.start();
  });

  // hoverが外れたときにautoplayを停止
  sliderElement.parentElement.addEventListener("mouseleave", function () {
    colorsSlider.autoplay.stop();
  });
});
